export default "__VITE_ASSET__CWib1zhU__"